import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { PrimaryGhostButton } from '@bibliocommons/deprecated-base-buttons';

import AccessibleDatePicker from 'app/components/shared/AccessibleDatePicker';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

import './HoldsPauseDateSelect.scss';

export default class HoldsPauseDateSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    const startDate = props.initialSuspendStartDate || moment();
    const endDate = props.initialSuspendEndDate ? props.initialSuspendEndDate : null;
    this.state = {
      openStartDateOverlay: false,
      openEndDateOverlay: false,
      suspended: {
        startDate,
        endDate,
        status: false
      }
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { startDate, endDate } = this.state.suspended;

    if (startDate !== prevState.suspended.startDate || endDate !== prevState.suspended.endDate) {
      this.props.onSelectDates(this.state.suspended);
    }
    return null;
  }

  renderPauseStartDatePickerOverlay() {
    const { openStartDateOverlay } = this.state;
    const { startDate, endDate } = this.state.suspended;
    const date = startDate || moment();

    return (
      <div className="suspend-start-date-field item-row">
        <span className="date-label">
          <FormattedMessage id="date_from" />
        </span>
        <AccessibleDatePicker
          open={openStartDateOverlay}
          className="start-date"
          id="suspend-start-date-picker"
          fullScreen={this.props.fullScreen}
          initialDate={date}
          handleClose={() => this.setState({ openStartDateOverlay: false })}
          onDateChange={fromDate =>
            this.setState(state => ({
              suspended: { ...state.suspended, startDate: fromDate }
            }))}
          minDate={moment()}
          maxDate={endDate}
          buttonTag={PrimaryGhostButton}
          handleOpen={() => this.setState({ openStartDateOverlay: true })}
        >
          <ShortFormattedDate value={moment(date).format('YYYY-MM-DD')} />
        </AccessibleDatePicker>
      </div>
    );
  }

  renderPauseEndDatePickerOverlay() {
    const { openEndDateOverlay } = this.state;
    const { startDate, endDate } = this.state.suspended;

    function getMinDate() {
      if (startDate && moment(startDate).isAfter(moment())) {
        return startDate;
      }
      return moment();
    }

    return (
      <div className="suspend-end-date-field item-row">
        <span className="date-label">
          <FormattedMessage id="date_until" />
        </span>
        <AccessibleDatePicker
          open={openEndDateOverlay}
          className="end-date"
          id="suspend-until-date-picker"
          fullScreen={this.props.fullScreen}
          initialDate={endDate}
          handleClose={() => this.setState({ openEndDateOverlay: false })}
          onDateChange={untilDate =>
            this.setState(state => ({
              suspended: { ...state.suspended, endDate: untilDate }
            }))}
          minDate={getMinDate()}
          buttonTag={PrimaryGhostButton}
          handleOpen={() => this.setState({ openEndDateOverlay: true })}
          highlightSelectedDateRange
        >
          {endDate ? <ShortFormattedDate value={endDate} /> : <FormattedMessage id="select_a_date" />}
        </AccessibleDatePicker>
      </div>
    );
  }

  render() {
    const { enableStartDate, enableEndDate } = this.props;

    return (
      <div className="cp-holds-pause-date-select">
        {enableStartDate && this.renderPauseStartDatePickerOverlay()}
        {enableEndDate && this.renderPauseEndDatePickerOverlay()}
      </div>
    );
  }
}

HoldsPauseDateSelect.defaultProps = {
  enableStartDate: false
};

HoldsPauseDateSelect.propTypes = {
  onSelectDates: PropTypes.func,
  enableStartDate: PropTypes.bool,
  fullScreen: PropTypes.bool,
  enableEndDate: PropTypes.bool,
  initialSuspendStartDate: PropTypes.string,
  initialSuspendEndDate: PropTypes.string
};
